module.exports = __webpack_public_path__ + "static/img/groupIcon.9204520.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/newIcon/groupIcon.png
// module id = /wHU
// module chunks = 1